import ApolloClient from '@/packages/apollo-client'

import {
	ADD_PART,
	CLEAR_CART,
	FETCH_PARTS,
	CREATE_CART,
	UPDATE_CART,
	DELETE_CART,
	FETCH_CART,
	FETCH_CART_PRODUCTS,
	ADD_TO_CART,
	REMOVE_FROM_CART,
	UPDATE_QUANTITY
} from './action-types'

import * as CART_MUTATIONS from './mutation-types'
import * as TABLE_MUTATIONS from '@/store/modules/Table/mutation-types'
import Logger from '@/packages/logger'

import FetchParts from './Schema/Queries/FetchParts.gql'
import FetchCart from './Schema/Queries/FetchCart.gql'
import FetchCartProducts from './Schema/Queries/FetchCartProducts.gql'

import CreateCart from './Schema/Mutations/CreateCart.gql'
import UpdateCart from './Schema/Mutations/UpdateCart.gql'
import DeleteCart from './Schema/Mutations/DeleteCart.gql'
import AddToCart from './Schema/Mutations/AddToCart.gql'


const validStatuses = ['in_stock', 'not_parsed']

const getNormalizedPartId = part => {
	const partId = part?.id || part?.partId
	return partId ? String(partId) : null
}

const collectUniqueParts = parts => {
	const stack = [...parts]
	const partsMap = new Map()

	while (stack.length) {
		const currentPart = stack.pop()
		if (!currentPart) {
			continue
		}

		const partId = getNormalizedPartId(currentPart)
		if (partId && !partsMap.has(partId)) {
			partsMap.set(partId, currentPart)
		}

		if (Array.isArray(currentPart.children) && currentPart.children.length) {
			stack.push(...currentPart.children)
		}
	}

	return partsMap
}

export default {
	async [ADD_PART] ({ commit, dispatch, state, rootState }, parts = []) {
		if (!Array.isArray(parts) || !parts.length) {
			return
		}

		let partsCount = 0
		const selectedDepartmentId = rootState['Auth'].user.selectedDepartmentId || parts?.[0].departmentId || parts?.[0]?.department?.id


		// if (selectedDepartmentId) {
		commit(CART_MUTATIONS.SET_LOADING, {
			addToCart: true
		})
		if (!rootState.Auth.user.selectedCartId) {

			const cart = await dispatch(CREATE_CART, {
				departmentId: selectedDepartmentId
			})

			if (!cart) {
				commit(CART_MUTATIONS.SET_LOADING, {
					addToCart: false
				})
				return
			}

		}
		commit(CART_MUTATIONS.SET_LOADING, {
			addToCart: false
		})

		const cartDepartmentId = state.cart?.departmentId || selectedDepartmentId
		const payloadPartsMap = collectUniqueParts(parts)
		const existingCartProductIds = new Set((state.cartProducts || []).map(product => String(product.recarId)))

		const partsToAdd = Array.from(payloadPartsMap.values())
			.filter(part => {
				const partId = getNormalizedPartId(part)
				if (!partId || existingCartProductIds.has(partId)) {
					return false
				}

				const departmentId = part.departmentId || part.department?.id || selectedDepartmentId
				if (departmentId !== cartDepartmentId) {
					return false
				}
				if (!rootState['Auth'].user.hasPermission('CREATE_ORDER', departmentId)) {
					return false
				}

				const isSellablePart = validStatuses.includes(part.status) && Number(part.price) > 0

				return isSellablePart
			})

		if (!partsToAdd.length) {
			return
		}

		const productsToAdd = partsToAdd.map(part => ({
			id: getNormalizedPartId(part),
			quantity: 1,
			productType: 'part'
		}))

		const previousProducts = state.cartProducts || []
		const optimisticProducts = [
			...previousProducts,
			...partsToAdd.map(part => ({
				...part,
				recarId: getNormalizedPartId(part),
				quantity: 1
			}))
		]

		commit(CART_MUTATIONS.SET_CART_PRODUCTS, optimisticProducts)

		try {
			await dispatch(ADD_TO_CART, {
				products: productsToAdd
			})
			partsCount = productsToAdd.length
		} catch (e) {
			commit(CART_MUTATIONS.SET_CART_PRODUCTS, previousProducts)
			commit(CART_MUTATIONS.SET_LOADING, {
				addToCart: false
			})
			Logger.captureException(e)
			return Promise.reject(e)
		}
		// }

		if (partsCount > 0) {
			// commit(
			// 	'Notification/ADD_NOTIFICATION',
			// 	`Į krepšelį sėkmingai pridėta ${partsCount} detalė(s)`,
			// 	{ root: true }
			// )
		}


	},

	[FETCH_PARTS] ({ commit, _state }, { ids, root = false }) {
		const query = {
			query: FetchParts,
			variables: {
				payload: {
					ids
				},
				page: 1,
				size: 999
			}
		}
		if (ids) {
			if (root) {
				commit(CART_MUTATIONS.SET_LOADING, true)
			}

			return ApolloClient.query(query)
				.then(({ data }) => {
					const parts = data.parts.nodes.map(part => {
						const { vehicleSpecifications, ...restPart } = part
						return { ...vehicleSpecifications, ...restPart, selectedQuantity: 1  }
					})
					if (root) {
						commit(`Table/${TABLE_MUTATIONS.SET_DATA}`, parts)
						commit(CART_MUTATIONS.SET_FULL_PARTS, parts)
						commit(CART_MUTATIONS.SET_LOADING, false)
					}
					return parts
				})
				.catch(err => {
					commit(CART_MUTATIONS.SET_LOADING, false)
					Logger.captureException(err)
					return err
				})
		}
	},

	[CLEAR_CART] ({ commit }) {
		commit(CART_MUTATIONS.CLEAR_CART)
	},

	async [UPDATE_QUANTITY] ({ _commit, _rootState, dispatch, state }, product) {
		try {
			const payload = {
				id: state.cart.id,
				// departmentId:
				clientId: state.cart.clientId,
				deliveryType: state.cart.deliveryType,
				products: state.cartProducts.map(item => {
					if (item.id !== product.id) {
						return	{
							id: item.recarId,
							quantity: item.quantity,
							productType: item.productType || 'oem_part'
						}
					}
					return {
						id: item.recarId,
						quantity: product.quantity,
						productType: item.productType || 'oem_part'
					}
				})
			}
			await dispatch(UPDATE_CART, payload)
		} catch (e) {
			return Promise.reject(e)
		}
	},

	async [REMOVE_FROM_CART] ({ state, dispatch, commit, _rootState }, product) {
		const backupProducts = [...state.cartProducts]
		const updateProducts = [...state.cartProducts.filter(item => item.id !== product.id)]
		try {
			commit(CART_MUTATIONS.SET_CART_PRODUCTS, updateProducts)
			const payload = {
				id: state.cart.id,
				// departmentId: rootState.Auth.user.selectedDepartmentId,
				clientId: state.cart.clientId,
				deliveryType: state.cart.deliveryType,
				products: state.cartProducts.filter(item => item.id !== product.id).map(item => ({
					id: item.recarId,
					quantity: item.quantity,
					productType: item.productType || 'oem_part'
				}))
			}

			const _data = await dispatch(UPDATE_CART, payload)
		} catch (_e) {
			commit(CART_MUTATIONS.SET_CART_PRODUCTS, backupProducts)
		}
	},

	async [ADD_TO_CART] ({ commit, rootState, dispatch, state }, payload) {
		commit(CART_MUTATIONS.SET_LOADING, {
			addToCart: true
		})
		if (rootState.Auth.user.selectedCartId) {
			const { id } = state.cart?.id === rootState.Auth.user.selectedCartId ? state.cart : await dispatch(FETCH_CART, rootState.Auth.user.selectedCartId)
			const mutation = {
				mutation: AddToCart,
				variables: {
					payload: {
						id,
						products: payload.products
					}
				}
			}
			if (!payload.clientId) {
				mutation.variables.payload.clientId = rootState?.OemParts?.searchFilters?.clientId || rootState?.Parts?.searchFilters?.clientId
			}
			try {
				await ApolloClient.mutate(mutation)
				await dispatch(FETCH_CART, id)
				commit(CART_MUTATIONS.SET_LOADING, {
					addToCart: false
				})
				const payload = {
					cartIds: [id],
					productQueryType: 'cart'
					// departmentIds: this.$auth().selectedDepartmentId ? [this.$auth().selectedDepartmentId] : null
				}
				await dispatch(FETCH_CART_PRODUCTS, payload)

			} catch (e) {
				commit(CART_MUTATIONS.SET_LOADING, {
					addToCart: false
				})
				return Promise.reject(e)
			}
		} else {
			const resp = await dispatch(CREATE_CART, payload)
			await dispatch(FETCH_CART_PRODUCTS, {
				cartIds: [resp.id],
				productQueryType: 'cart'
			})
			commit(CART_MUTATIONS.SET_LOADING, {
				addToCart: false
			})
		}
	},

	async [CREATE_CART] ({ dispatch, commit, rootState }, payload) {
		commit(CART_MUTATIONS.SET_LOADING, {
			createCart: true
		})

		if (!payload.departmentId) {
			payload.departmentId = rootState.Auth.user.selectedDepartmentId
		}
		const mutation = {
			mutation: CreateCart,
			variables: {
				payload
			}
		}
		if (!payload.clientId) {
			mutation.variables.payload.clientId = rootState?.OemParts?.searchFilters?.clientId || rootState?.Parts?.searchFilters?.clientId
		}
		try {
			const { data } = await ApolloClient.mutate(mutation)
			commit(CART_MUTATIONS.SET_CART, data.createCart)
			// Ensure the lazy Users module is registered before the cross-module dispatch
			await import('@/store/modules/Users/helpers')
			await dispatch('Users/EDIT_USER', {
				id: rootState.Auth.user.id,
				selectedCartId: data.createCart.id
			}, { root: true })
			commit(CART_MUTATIONS.SET_LOADING, {
				createCart: false
			})
			return data.createCart

		} catch (_e) {
			commit(CART_MUTATIONS.SET_LOADING, {
				createCart: false
			})
		}
	},

	async [DELETE_CART] ({ commit, dispatch, rootState }, payload) {
		commit(CART_MUTATIONS.SET_LOADING, {
			deleteCart: true
		})
		const mutation = {
			mutation: DeleteCart,
			variables: {
				payload
			}
		}

		try {
			const { data } = await ApolloClient.mutate(mutation)
			// Ensure the lazy Users module is registered before the cross-module dispatch
			await import('@/store/modules/Users/helpers')
			await dispatch('Users/EDIT_USER', {
				id: rootState.Auth.user.id,
				selectedCartId: null
			}, { root: true })
			commit(CART_MUTATIONS.SET_CART, null)
			commit(CART_MUTATIONS.SET_CART_PRODUCTS, null)
			commit(CART_MUTATIONS.SET_LOADING, {
				deleteCart: false
			})
			return data.deleteCart?.status
		} catch (_e) {
			commit(CART_MUTATIONS.SET_LOADING, {
				deleteCart: false
			})
		}
	},

	async [UPDATE_CART] ({ commit }, payload) {
		commit(CART_MUTATIONS.SET_LOADING, {
			updateCart: true
		})
		const mutation = {
			mutation: UpdateCart,
			variables: {
				payload
			}
		}
		try {
			const { data } = await ApolloClient.mutate(mutation)
			// commit(CART_MUTATIONS.SET_CART, data.updateCart)
			commit(CART_MUTATIONS.SET_LOADING, {
				updateCart: false
			})
			return data.updateCart

		} catch (e) {
			commit(CART_MUTATIONS.SET_LOADING, {
				updateCart: false
			})
			return Promise.reject(e)
		}
	},

	async [FETCH_CART] ({ commit }, id) {
		commit(CART_MUTATIONS.SET_LOADING, {
			cart: true
		})
		const query = {
			query: FetchCart,
			variables: {
				id
			}
		}
		try {
			const { data } = await ApolloClient.query(query)
			commit(CART_MUTATIONS.SET_CART, data.cart)
			commit(CART_MUTATIONS.SET_LOADING, {
				cart: false
			})
			return data.cart

		} catch (_e) {
			commit(CART_MUTATIONS.SET_LOADING, {
				createCart: false
			})
		}
	},

	async [FETCH_CART_PRODUCTS] ({ commit }, payload) {
		commit(CART_MUTATIONS.SET_LOADING, {
			cartParts: true
		})
		const query = {
			query: FetchCartProducts,
			variables: {
				payload
			}
		}
		try {
			const { data } = await ApolloClient.query(query)
			commit(CART_MUTATIONS.SET_CART_PRODUCTS, data.orderProductsNew)
			commit(CART_MUTATIONS.SET_LOADING, {
				cartParts: false
			})
			return data.cart

		} catch (_e) {
			commit(CART_MUTATIONS.SET_LOADING, {
				cartParts: false
			})
		}
	}
}
